import {Component} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {EndorsementService} from "../service/endorsement/endorsement.service";
import {DownloadDocumentService} from "../service/download-document/download-document.service";

@Component({
  selector: 'app-endorse-effective-date',
  templateUrl: './endorse-effective-date.component.html',
  styleUrls: ['./endorse-effective-date.component.css']
})
export class EndorseEffectiveDateComponent {

  dataDashboard : any = {}
  login : any = {}
  formEndorse : FormGroup
  minDate : string = "";
  maxDate : string = "";
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private endorsementService: EndorsementService,
    private documentService: DownloadDocumentService
  ) {
    let background = document.getElementById("background");
    if (background != null) {
      background.className = "allianz-background-faded"
    }

    let jsonLogin = sessionStorage.getItem("login")
    if (jsonLogin) {
      this.login = JSON.parse(jsonLogin);
    }

    let jsonDataDashboard = localStorage.getItem("selected-item")
    if (jsonDataDashboard) {
      this.dataDashboard = JSON.parse(jsonDataDashboard);
    }

    this.formEndorse = this.formBuilder.group({
      tanggalMulai: [{
        value: this.dataDashboard.effectiveDate,
        disabled: true
      }],
      tanggalEndorse: ['', [Validators.required, this.setMinMaxDate()]],
    })

    // this.setMinMaxDate()
  }

  setMinMaxDate() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value

      const inputDate = new Date(value)
      // this.dataDashboard.effectiveDate = '2025-09-20'
      let startDate = new Date(Date.parse(this.dataDashboard.effectiveDate))
      let endDate = new Date(Date.parse(this.dataDashboard.effectiveDate))

      //add one day to min date
      startDate.setDate(startDate.getDate() + 1)
      //add 30 days to max date
      endDate.setDate(endDate.getDate() + 31)
      this.minDate = startDate.toISOString().split("T")[0]
      this.maxDate = endDate.toISOString().split("T")[0]

      //calculate nearest birthday zone (this year birthday - 183 days)
      // this.dataDashboard.dob = "1998-03-29"
      // let additionalDate = new Date(Date.parse(this.dataDashboard.dob))
      //
      // additionalDate.setFullYear(new Date().getFullYear())
      // additionalDate.setDate(additionalDate.getDate() + 182)
      // let dateDiffMilliSec = additionalDate.getTime() - endDate.getTime();
      // let dateDiff = Math.ceil(dateDiffMilliSec / (1000 * 60 * 60 * 24))
      //
      // if (dateDiff < 0) {
      //   this.maxDate = additionalDate.toISOString().split("T")[0]
      //   endDate = additionalDate
      // }
      if (inputDate > endDate || inputDate < startDate) {
        return {'maxEffectiveDateError': true}
      }
      return null;
    }
  }

  back() {
    this.router.navigate(['dashboard/insured-summary/' + this.dataDashboard.referenceNo + '/' + this.login.partnerId])
  }

  continue() {
    if (this.formEndorse.valid) {
      const endorsementRequest = {
        PartnerCode: this.login.partnerCode ?? "BTPN0422",
        ProductCode: this.dataDashboard.productCode,
        ReferenceNo: this.dataDashboard.referenceNo,
        effectiveDate: this.formEndorse.controls['tanggalEndorse'].value,
      }
      this.endorsementService.endorsement(endorsementRequest).subscribe(res => {
        localStorage.setItem("endorsement-response", JSON.stringify(res))
        if (res.statusId == "1") {
          this.documentService.generateLetterBtpn({
            "refnum": this.dataDashboard.referenceNo,
            "memberstatus": "APPROVED"
          }).subscribe( res =>{
            this.router.navigate(['eform/dashboard/endorse-final'])
          })
        } else {
          this.router.navigate(['eform/dashboard/endorse-final'])
        }
      })
    }
  }

  // @ViewChild('btnAcceptance')
  // btnAcceptance!: ElementRef;
  // downloadDocument() {
  //   this.documentService.downloadDocument({
  //     referenceNo: this.dataDashboard.referenceNo,
  //     docType: "ACCEPTANCE"
  //   }).subscribe(res => {
  //     console.log("ress", res)
  //     this.btnAcceptance.nativeElement.download = 'Surat Akseptasi ' + this.dataDashboard.referenceNo + '.pdf'
  //     this.btnAcceptance.nativeElement.href = 'data:application/octet-stream;base64,' + res.document;
  //     this.btnAcceptance.nativeElement.click()
  //   })
  // }
  //
  // generate() {
  //   this.documentService.generateLetterBtpn({
  //     "refnum": this.dataDashboard.referenceNo,
  //     "memberstatus": "APPROVED"
  //   }).subscribe( res =>{
  //     console.log("yoo", res)
  //     // this.router.navigate(['eform/dashboard/endorse-final'])
  //   })
  // }
}
